/**
 * Get Example Campaign Selector
 *
 */
export const getExampleCampaigns = () =>
  /**
   * @param {import("stores/reducers").MainReducer} state
   */
  state => state.exampleCampaigns;
